$(document).on('turbolinks:load', function () {
  selectHandler.init($('#company_id'), $('#event_id'));
});

var selectHandler = (function (w, d, $) {

  var toast = function (msg, type) {
    toastr[type](msg);
    toastr.options.timeOut = 500;
    toastr.options.extendedTimeOut = 1000;
  }

  var init = function ($selector) {
    var selectorOptionLength = $selector.find('option').length;
    var selectorValue = $selector.val();
    var variableText = $selector.attr('id') == 'company_id' ? 'una empresa' : 'un evento'
    if (selectorValue == 0 && selectorOptionLength > 1) {
      event.preventDefault();
      toast('Debes seleccionar ' + variableText, 'info');
      $selector.css('border', '2px solid red');
    }
  };

  return {
    init: function ($selectorPromoter, $selectorEvent) {
      if (!!$selectorPromoter)
        init($selectorPromoter)
      if (!!$selectorEvent)
        init($selectorEvent)
    }
  };
}(window, document, jQuery));